// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12Vu9","title":"styles_title__3zbYH"};